import { GridOptions } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import {  VALUE_ENTER, WIZ_EVENT_TYPE, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizEvent, WizEventManager
} from '@wizeoo/akm-component-lib';
import { ColDef } from 'ag-grid-community';
import { WizColDef } from '../../../../manager/workingdata/fei.engine';
import { WizConstants } from '@wizeoo/akm-compute-lib';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { Model } from '../../../../model/model';
import { ChronocodeVO } from  '../../../../vo/core/chronocode.vo';
import { ViewData } from '../../../../model/view.data';
import { IForm } from '../../../../manager/widgets/i-form';

@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'form-drop-extended-chronocode-pop',
  templateUrl: './form-drop-extended-chronocode.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDropExtendedChronocodePop extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  gridOptions: GridOptions = {
    // suppressRowClickSelection: true,
    onRowDoubleClicked: (params) => this.onRowDouble(params)
  };


  public ffo: FormFieldObj; // l'objet source
  public currentValue: string; // la valeur en cours
  public declare callback: Function; // fonction de retour vers le pivotComponent pour application

  public chrono: ChronocodeVO;
  public level: number;
  private doSaveFlag: boolean = true;

  @ViewChild('agGrid') agGrid: WizAgGrid<ChronocodeVO>;
  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre


  public get model(): Model {
    return this.ffo.widget.model;
  }

  public dataDS: WizDatasource<ChronocodeVO> = new WizDatasource<ChronocodeVO>([]) // DS de la liste
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();



  public keyGridColumns: ColDef[] = [];

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    this.ffo = this.datas[0];
    this.currentValue = this.datas[1];
    this.callback = this.datas[2];

    this.feed();
    this.addListeners();
  }


  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: ChronocodeVO): boolean {
    if(item.deprecated) { // masquer les deprecated
      return false;
    }
    
    // TODO TODO prise en compte des ancêtres

    return this.popFilter.checkVisible(item);
  }


  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {


    this.level = Number(this.ffo.fkd.fullCode.split(ViewData.CONTEXT_SEPARATOR)[1]);
    this.chrono = this.model.chronocodeEngine.getChronocode(this.model.visionEngine.getVision(this.ffo.fei.vision.code).chronoCode);
    let chronos: ChronocodeVO[] = this.model.chronocodeEngine.getChildrenByLevel(this.chrono, this.level);
 
    this.keyGridColumns = [];
    let col: WizColDef;

    col = { headerName: '$.chrono.field.label.$',
    field: 'trsLabel',
    sortable: true,
    resizable: false,
    flex: 1,
    tooltipField: 'trsLabel'};
    this.keyGridColumns.push(col);

    col = { headerName: '$.chrono.field.startdate.$',
    field: 'startDateStr',
    sortable: true,
    resizable: false,
    width: 100,
    tooltipField: 'startDateStr'};
    this.keyGridColumns.push(col);

    this.popFilter.configure(['trsLabel', 'startDateStr'], null, null).build();

    let sortKey: any = {property: 'startDate', way: 'asc', numeric: true};

    chronos = this.restrictFromAncestor(chronos)

    this.dataDS.setSource(chronos);
    this.dataDS.setSortFields([sortKey]);
    this.dataDS.refresh();
    
    
    let chron: ChronocodeVO = null;
    if (this.currentValue) {
      chron = this.dataDS.getItemByKey(this.currentValue);
    }
    this.dataDS.select([chron]);
  }


  /**
   * Refresh du filtre
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshFilter(event: WizEvent = null): void {
    this.dataDS.refresh();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // Filtres
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.refreshFilter);
  }

  /** double-clic sur une ligne, sélection single auto + dispatch */
  private onRowDouble(params: any): void {
    // console.log('onRow2x', params);
    this.dataDS.select([params.data]);
    this.save();
  }


  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  public onHide() {
    if (this.doSaveFlag) {
      const val: string = this.dataDS.selectedItem ? this.dataDS.selectedItem.code : null;
      // this.ffo.widget.keyPartMap.set(this.ffo.fkd.fullCode, val);
      this.callback(val);
    }
  }

  // les clés actives sur le même FD / CHRONO que mois
  private ancestorKey: string = null;

  // /** construction du set de valeurs de mes ancêtres dans le widget. Pour application rapide de la filterFunc */
  private restrictFromAncestor(chronos: ChronocodeVO[]): ChronocodeVO[] {
    if (!this.ffo?.fkd) {
      return chronos;
    }
    
    if(!this.ancestorKey) { // alimentation du set d'ancêtres
      const strictCode: string = this.ffo.fkd.code; // clé simple (sans #lvl)
      const refLevel = this.ffo.fkd.level; // référence du level en cours
      if(refLevel > 1) { // pas besoin au premier niveau
        // prise des clés sur le widget
        let keyPartMap: Map<string, string> = (this.ffo.widget as IForm).keyPartMap;
    
        // prise du level de l'ancêtre, au plus proche, au mieux
        let referenceLevel: number = -1;

        Array.from(keyPartMap.keys()).forEach((inMapKey) => {
          if(!!inMapKey) {
            const inMapStrict = inMapKey.split(ViewData.CONTEXT_SEPARATOR)[0];
            if (inMapStrict === strictCode) {
              const inMapLevel: number = Number(inMapKey.split(ViewData.CONTEXT_SEPARATOR)[1]);
              if (inMapLevel < refLevel && // un ancêtre
                  !!keyPartMap.get(inMapKey) && // avec une valeur
                  inMapLevel > referenceLevel) { // et plus proche que ce que j'ai déjà identifié
                
                let key: string = keyPartMap.get(inMapKey);
                if(key !== WizConstants.wildcardDomain) { // les chronos sont pas vide, c'est *
                  referenceLevel = inMapLevel;
                  this.ancestorKey = key;
                }
              }
            }
          }
        });
      }


    }

    let allowed: ChronocodeVO[] = [];
    if(!this.ancestorKey) { // pas d'ancêtre, tout est OK
      allowed = chronos;
    } else { // l'ancêtre doit être dans ma pile d'héritage
      
      chronos.forEach((chron: ChronocodeVO) => {
        if(chron.code.startsWith(this.ancestorKey)) { // c'est mon ancêtre
          allowed.push(chron);
        }
      });

    }
    return allowed;  
  }

}

